<template>
  <div class="tecRussia-container">
    <RussiaEconRev :countryId="countryId" :unfriendlyCountryInfo="unfriendlyCountryInfo" />
    <WorldEconRev :countryId="countryId" />
  </div>
</template>

<script>
  import RussiaEconRev from './RussiaEconRev.vue';
  import WorldEconRev from './WorldEconRev.vue';

  export default {
    name: 'TecRussia',
    components: {
      RussiaEconRev,
      WorldEconRev,
    },
    props: {
      countryId: {
        type: String,
        default: '',
      },
      unfriendlyCountryInfo: {
        type: Object,
        default: () => ({}),
      },
    },
  };
</script>

<style scoped lang="scss">
  .tecRussia-container {
    display: flex;
    flex-direction: column;
    gap: 30px;
    margin-bottom: 40px;
  }
</style>
